export default "/images/vendor/flag-icons/flags/1x1/cl.svg?5e19099caf3daa730ce58ad926af8964";